import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MSAL_GUARD_CONFIG, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
import { RedirectRequest } from '@azure/msal-browser';


@Injectable({
  providedIn: 'root'
})
export class AuthService {
  profile: any;

  constructor(@Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration, private msalService: MsalService, private router: Router) { }

  getUserDetails(){
    const profileData = this.msalService.instance.getAllAccounts()[0] || false;
    if(profileData){
      console.log("2", profileData);
        this.profile = {name: profileData.name, mail: profileData.username}
        return this.profile;
    }
    return false
  }

  getUserToken(){
    const profileData = this.msalService.instance.getAllAccounts()[0] || false;
    if(profileData){
        this.profile = {token: profileData}
        return this.profile;
    }
    return false
  }

  microsoftLogin() {
    if (this.msalGuardConfig.authRequest){
      this.msalService.loginRedirect({...this.msalGuardConfig.authRequest} as RedirectRequest);
    } else {
      this.msalService.loginRedirect();
    }
  }

  microsoftLogout() {
    this.msalService.logoutRedirect({
      postLogoutRedirectUri: "/"
    });
  }
}
